import { render, staticRenderFns } from "./ChatRoom.htm?vue&type=template&id=046f1bfc&scoped=true&"
import script from "./ChatRoom.ts?vue&type=script&lang=js&"
export * from "./ChatRoom.ts?vue&type=script&lang=js&"
import style0 from "./ChatRoom.scss?vue&type=style&index=0&id=046f1bfc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046f1bfc",
  null
  
)

export default component.exports